import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    {
      staticClass: "review-card-tooltips",
      attrs: { "data-review-card-tooltips": "" },
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex",
          class: { "flex-column align-start": !_vm.isMobile },
        },
        [
          _c(
            VMenu,
            {
              attrs: {
                "z-index": "110",
                attach: "",
                disabled: !_vm.assessmentsTransformed.length,
                "close-on-content-click": false,
                "open-on-hover": !_vm.isMobile,
                "offset-y": "",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "div",
                          _vm._g(
                            _vm._b({ ref: "stars" }, "div", attrs, false),
                            on
                          ),
                          [_vm._t("stars")],
                          2
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            },
            [
              _vm._v(" "),
              _c(
                VCard,
                { staticClass: "pa-5", attrs: { elevation: "0" } },
                _vm._l(
                  _vm.assessmentsTransformed,
                  function (assessment, index) {
                    return _c(
                      "div",
                      { key: assessment.name, class: { "mt-4": index > 0 } },
                      [
                        _c("div", { staticClass: "text-no-wrap" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(assessment.name) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _vm._l(assessment.filledStars, function (i) {
                              return _c(
                                VIcon,
                                {
                                  key: `filled-${i}`,
                                  class: { "ml-1": i > 1 },
                                  attrs: { color: "rating", small: "" },
                                },
                                [
                                  _vm._v(
                                    "\n              ui-icon-rating-star-filled\n            "
                                  ),
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(assessment.outlineStars, function (i) {
                              return _c(
                                VIcon,
                                {
                                  key: `outline-${i}`,
                                  staticClass: "ml-1",
                                  attrs: { color: "rating", small: "" },
                                },
                                [
                                  _vm._v(
                                    "\n              ui-icon-rating-star-outline\n            "
                                  ),
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "text-capitalize ml-2",
                                class: assessment.color,
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(assessment.status) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          2
                        ),
                      ]
                    )
                  }
                ),
                0
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { class: _vm.isMobile ? "ml-2" : "mb-2" }),
          _vm._v(" "),
          _c(
            VMenu,
            {
              attrs: {
                "z-index": "110",
                attach: "",
                "nudge-left": _vm.isMobile
                  ? _vm.statusesTooltipOffset
                  : undefined,
                "close-on-content-click": false,
                "open-on-hover": !_vm.isMobile,
                "offset-y": "",
              },
              on: { input: _vm.handleOpenStatusesTooltip },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "div",
                          _vm._g(
                            _vm._b(
                              { on: { mouseenter: _vm.updateOffset } },
                              "div",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [_vm._t("statuses")],
                          2
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            },
            [
              _vm._v(" "),
              _c(
                VCard,
                {
                  staticClass: "text--text",
                  attrs: { width: "304", elevation: "0" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "pa-4" },
                    [
                      _c("div", { staticClass: "text-subtitle-1" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$i18next.t("Отзыв проверен", _vm.options)
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.verificationStatuses, function (status) {
                        return _c(
                          "div",
                          { key: status, staticClass: "d-flex mt-2" },
                          [
                            _c("div", {
                              domProps: { innerHTML: _vm._s(status) },
                            }),
                            _vm._v(" "),
                            _c(VSpacer),
                            _vm._v(" "),
                            _c(VIcon, { attrs: { color: "text-success" } }, [
                              _vm._v(
                                "\n              ui-icon-check\n            "
                              ),
                            ]),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(VDivider),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-center text-caption text-secondary--text pa-4",
                    },
                    [
                      _c(VIcon, { attrs: { dense: "" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.originInfo.icon) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ml-3" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$i18next.t("Оставлен через", _vm.options)
                            ) +
                            " " +
                            _vm._s(_vm.originInfo.text) +
                            "\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }